<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content
        [showDefaultFormFooter]="true"
        [showCreate]="true"
        [contentClasses]="['floatingLabelContainer']"
    >
        <div class="d-flex w-100 gap-2">
            <p-floatlabel variant="on" class="w-50">
                <input id="key" type="text" pInputText formControlName="key" (appInputDebounce)="onKeyChanged()" />
                <label for="key">Key</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="w-25">
                <p-select
                    inputId="vtype"
                    [autoDisplayFirst]="false"
                    [options]="vtypeOptions"
                    formControlName="vtype"
                    optionLabel="label"
                    optionValue="value"
                    appendTo="body"
                ></p-select>
                <label for="vtype">Type</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="w-25">
                <p-treeSelect
                    formControlName="schema"
                    containerStyleClass="width-form"
                    [options]="schemasTreeRoot.children"
                    title="Select a schema for this object store entry"
                    emptyMessage="No schema found"
                    [filter]="true"
                    [filterInputAutoFocus]="true"
                    selectionMode="single"
                    [showClear]="isCreationMode"
                    appendTo="body"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="35"
                    [virtualScrollOptions]="{scrollHeight: '20rem'}"
                ></p-treeSelect>
                <label for="schema">Schema</label>
            </p-floatlabel>
        </div>
        @if (vtypeSchema) {
            <p-panel class="with-borders plain-header">
                <ng-template #header>
                    <div class="hcol-flex align-center">
                        <p-checkbox
                            [binary]="true"
                            [(ngModel)]="hasValue"
                            [ngModelOptions]="{standalone: true}"
                            [disabled]="
                                dialogOpenMode === EDialogOpenMode.READ_ONLY ||
                                dialogOpenMode === EDialogOpenMode.REVERT
                            "
                        ></p-checkbox>
                        <span class="font-bold">Value</span>
                    </div></ng-template
                >
                <div [ngStyle]="{opacity: hasValue ? '1' : '0.5'}">
                    @if (!showLoading) {
                        @for (version of [vtypeSchemaVersion]; track version) {
                            <app-json-schema-form
                                #valueForm
                                [schema]="vtypeSchema"
                                [initData]="valueData"
                                [readOnly]="
                                    !hasValue ||
                                    dialogOpenMode === EDialogOpenMode.READ_ONLY ||
                                    dialogOpenMode === EDialogOpenMode.REVERT
                                "
                                (validityChangedEvent)="valueValid = $event"
                            ></app-json-schema-form>
                        }
                    }
                </div>
            </p-panel>
        } @else {
            <p-message
                class="m-1"
                severity="info"
                text="Select a type and a schema to edit the value of this object store entry"
            ></p-message>
        }
    </app-ibase-cru-modal-content>
</form>
